import { compose } from 'redux';

import { FieldType } from 'constants/formGenerator';
import { counselingFormatOptions, homeBuyerCounselingOptions } from 'constants/loanApplication';
import { getConditionalArray } from 'utils/data';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';

import { sectionStyles, sectionTitleStyles, textFieldStyles } from '../Declarations.styles';

export const getConfigFields = ({ entityId }) => {
  const modelPath = `[${entityId}].declarations.homeCounseling.`;

  return {
    homeBuyerCounseling: {
      label: 'homeBuyerCounseling',
      type: FieldType.SELECT,
      nameInModel: `${modelPath}homeBuyerCounseling`,
      inputProps: {
        options: homeBuyerCounselingOptions,
        placeholder: 'HomeBuyer Counseling',
        label: 'HomeBuyer Counseling',
        customStyles: textFieldStyles,
        disabled: false,
        required: false,
      },
    },
    counselingOtherDescription: {
      label: 'counselingOtherDescription',
      type: FieldType.INPUT,
      nameInModel: `${modelPath}counselingOtherDescription`,
      inputProps: {
        maxLength: 256,
        placeholder: 'Counseling Other Description',
        label: 'Counseling Other Description',
        customStyles: textFieldStyles,
        disabled: false,
        required: true,
      },
    },
    counselingFormat: {
      label: 'counselingFormat',
      type: FieldType.SELECT,
      nameInModel: `${modelPath}counselingFormat`,
      inputProps: {
        options: counselingFormatOptions,
        placeholder: 'Counseling Format',
        customStyles: textFieldStyles,
        label: 'Counseling Format',
        disabled: false,
        required: false,
      },
    },
    formatOtherDescription: {
      label: 'formatOtherDescription',
      type: FieldType.INPUT,
      nameInModel: `${modelPath}formatOtherDescription`,
      inputProps: {
        customStyles: textFieldStyles,
        maxLength: 256,
        placeholder: 'Format Other Description',
        label: 'Format Other Description',
        disabled: false,
        required: true,
      },
    },
  };
};

export const getConfig = compose(
  fillConfigFieldsWithKeys,
  ({ entityId, isHomeBuyerOther, isCounselingOther }) => {
    const configFields = getConfigFields({ entityId });

    return {
      groups: [
        {
          title: {
            label: 'Home Possible',
            titleStyles: sectionTitleStyles,
          },
          key: `${entityId}-declarations-home-counseling`,
          customStyles: { ...sectionStyles, gap: '24px' },
          type: FieldType.GROUP,
          fields: [
            configFields.homeBuyerCounseling,
            ...getConditionalArray(isHomeBuyerOther, [configFields.counselingOtherDescription]),

            configFields.counselingFormat,
            ...getConditionalArray(isCounselingOther, [configFields.formatOtherDescription]),
          ],
        },
      ],
    };
  },
);
